// File size in bytes
export default {
    kb: 1024,
    mb: 1048576,
    gb: 1073741824,
    tb: 1099511627776, // 1024 ^ 4
};
